<template>
  <div class="smart2_Com_6">
    <title1 type="1" title="场站评分"> </title1>
    <div class="Com_bottom">
      <div class="diamondBox image-3d">
        <div class="msgBox">
          <div class="number">{{number}}</div>
          <div class="label">场站评分</div>
        </div>
      </div>
      <div class="bottom_1">
        <div class="name">{{clusterData[indexc].stationName || '-'}}</div>
        <div class="address">{{clusterData[indexc].detailed_address || '-'}}</div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import title1 from "@/views/exposition/components/title4";
import MyEcharts from "@/views/exposition/components/charts/echarts.vue";
import * as echarts from "echarts5";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    MyEcharts,
    title1,
  },
  data() {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    const day = now.getDate().toString().padStart(2, "0");
    const ToDay = `${year}-${month}-${day}`;
    const ToMonth = `${year}-${month}`;
    const ToYear = `${year}`;
    return {
      showcdata: false,
      now: ToDay,
      tabList: [
        {
          name: "日",
          date: ToDay,
        },
        {
          name: "月",
          date: ToMonth,
        },
        {
          name: "年",
          date: ToYear,
        },
      ],
      indexc: 0,
      query: this.$route.query,
      timer: null,
      flag: false,
      index: 0,
      number : 90,
      clusterData: []
    };
  },
  mounted() {
    this.getBattery24hours();
    this.timer = setInterval(() => {
      this.indexc++;
      this.number = this.generateRandomNumber(90,100)
    }, 3 * 1000);
    this.$EventBus.$on('label', data => {
      clearInterval(this.timer);
        console.log('Event: ',data);
        this.indexc = 0
        this.clusterData[0].stationName = data.stationName || ''
        this.clusterData[0].detailed_address = data.detailed_address || ''
        this.timer = setInterval(() => {
            this.indexc++;
            this.number = this.generateRandomNumber(90,100)
        }, 6 * 1000);
    });
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    //获取24小时电次数分布
    getBattery24hours(date = this.now) {

        this.clusterData = JSON.parse(localStorage.getItem("clusterData"));
    },
    generateRandomNumber(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
  },
};
</script>
  
<style lang="scss" scoped>
@import "@/assets/scss/comm.scss";
$--l: white;
.smart2_Com_6 {
  width: 440px;
  height: 360px;
  // background: pink;
  .Com_bottom {
    margin-top: 20px;
    width: 100%;
    height: 100%;
    // background: pink;
    display: flex;
    flex-direction: column;

    align-items: center;
    .diamondBox {
      width: 220px;
      height: 220px;
      background: url(~@/assets/images/smart/back-2.png);
      background-size: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .msgBox {
        width: 100px;
        height: 50px;
        // background: red;
        display: flex;
        flex-direction: column;
        align-items: center;
        .number {
          font-size: 37px;
          line-height: 40px;
          @include ffamily-DS;
        }
        .label {
          font-size: 20px;
        }
      }
    }
    .bottom_1 {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .name{
        font-size: 20px;
      }
      .address{
        font-size: 22px;
        text-align: center;
      }
    }
  }
}

.image-3d {
  transform: perspective(1000px) rotateY(10deg);
  // box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);
}
</style>